import { niceDomain, scale, smoothPath, segments } from './svgPath';

interface Props { data: { label: string; value: number | null }[]; passMark: number; ariaLabel: string }

export default function AreaTrendChart({ data, passMark, ariaLabel }: Props) {
  const vals = data.map((d) => d.value);
  const runs = segments(vals);
  if (runs.length === 0) {
    return <p className="py-16 text-center text-sm text-muted">No scores in this window yet</p>;
  }
  const finite = runs.flat().map((p) => p.v);
  const [lo, hi] = niceDomain([...finite, passMark]);
  const x = scale(0, Math.max(1, data.length - 1), 50, 740);
  const y = scale(lo, hi, 200, 20);
  const ticks: number[] = []; for (let t = lo; t <= hi; t += 10) ticks.push(t);
  const last = runs[runs.length - 1][runs[runs.length - 1].length - 1];
  const lx = x(last.i), ly = y(last.v);
  const every = Math.max(1, Math.ceil(data.length / 6));
  return (
    <svg viewBox="0 0 760 240" className="block h-auto w-full" role="img" aria-label={ariaLabel}>
      {ticks.map((t) => (
        <g key={t}>
          <line x1={40} x2={750} y1={y(t)} y2={y(t)} className="stroke-line" />
          <text x={30} y={y(t) + 4} textAnchor="end" className="fill-muted font-mono text-[11px]">{t}</text>
        </g>
      ))}
      {runs.map((run, k) => {
        const pts = run.map((p) => [x(p.i), y(p.v)] as [number, number]);
        const line = smoothPath(pts);
        const area = `${line} L${pts[pts.length - 1][0]},200 L${pts[0][0]},200 Z`;
        return (
          <g key={k}>
            <path d={area} className="fill-slate" fillOpacity={0.12} />
            <path d={line} fill="none" className="stroke-slate-ink" strokeWidth={3} strokeLinejoin="round" strokeLinecap="round" />
          </g>
        );
      })}
      <line x1={40} x2={750} y1={y(passMark)} y2={y(passMark)} className="stroke-accent-ink" strokeWidth={1.5} strokeDasharray="5 5" />
      <circle cx={lx} cy={ly} r={7} className="fill-surface stroke-accent" strokeWidth={4} />
      <rect x={Math.min(lx - 69, 672)} y={ly - 44} width={78} height={28} rx={8} className="fill-navy" />
      <text x={Math.min(lx - 30, 711)} y={ly - 25} textAnchor="middle" className="fill-white font-mono text-[13px] font-semibold">
        {`${last.v.toFixed(1)}%`}
      </text>
      {data.map((d, i) => (i % every === 0 || i === data.length - 1) && (
        <text key={i} x={x(i)} y={230} textAnchor="middle" className="fill-muted font-mono text-[11px]">{d.label}</text>
      ))}
    </svg>
  );
}
